import {akLogin,akRegister} from '@/api/user.js';
import {setToken} from '@/utils/auth'
import vm from '@/main.js'

let Base64 = require('js-base64').Base64;

const user = {
    namespaced: true,
    state: {
        userInfo: '',
    },
    mutations: {
        SET_USER_INFO: (state, userInfo) => {
            state.userInfo = userInfo
        },
        SET_TOKEN: (state, token) => {
            state.token = token
        },
    },

    actions: {

        /**
         * 登录
         * @param commit
         * @param userInfo
         * @returns {Promise<any>}
         */
        login({ commit }, loginData) {
            let {
                phoneNumber,
                loginPassword
            } = loginData
            loginPassword = Base64.encode(loginPassword)
            return new Promise((resolve, reject) => {
                akLogin({
                    phoneNumber: phoneNumber.trim(),
                    loginPassword
                }).then(response => {
                    const data = response
                    commit('SET_TOKEN', data)
                    setToken(data)
                    resolve(data)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        /**
         * 登录
         * @param commit
         * @param userInfo
         * @returns {Promise<any>}
         */
        register({ commit }, loginData) {
            let {
                phoneNumber,
                loginPassword,
                phoneCode
            } = loginData
            loginPassword = Base64.encode(loginPassword)
            return new Promise((resolve, reject) => {
                akRegister({
                    phoneNumber: phoneNumber.trim(),
                    loginPassword,
                    phoneCode
                }).then(response => {
                    const data = response
                    commit('SET_TOKEN', data)
                    setToken(data)
                    resolve(data)
                }).catch(error => {
                    reject(error)
                })
            })
        },


        /**
         * 退出登录
         */
        resetToken({ commit }) {
            return new Promise((resolve) => {
                commit('SET_TOKEN', '')
                setToken('')
                resolve()
            })
        },

        /**
         * 获取用户信息
         * @param commit
         * @returns {Promise<any>}
         * @constructor
         */
        queryUserInfo({commit}) {
            return new Promise((resolve, reject) => {
                getUserInfo().then(res => {
                    commit('SET_USER_INFO', res);
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
    }
}

export default user
